<div id="mi-request-details" class="mi-request-details" miFocusOnTab>
    @if (this.formisForm.fields.length> 0) {
    <div id="mi-request-details-content" class="container" tabindex="-1" miFocusOnTab>
        <div class="row justify-content-center">
            <div class=" col-12 mi-panel-wrraper standart">
                <div class="mi-panel-content">
                    <div class="mc-my-3">
                        <span class="mi-header">{{tabsText.requestDetails}}</span>

                    </div>

                    <div class="mi-white-panel with-shadow">
                        <div class="mi-back ">
                            <mc-button [label]="genericText?.back" [ariaLabel]="genericText?.back"
                                [icon]="'pi pi-fw pi-chevron-right'" class="mi-button-with-icon-primary"
                                id="mi-request-details-back" (click)="moveToProduct()"
                                (keyup.enter)="moveToProduct()"></mc-button>
                        </div>


                        <mc-field-form [formisForm]="formisForm">
                        </mc-field-form>


                    </div>
                </div>
                <div class="row justify-content-center     justify-content-md-start">
                    <div class=" mi-next blue-button col-md-3 col-12">
                        <mc-button [label]="genericText?.next + ' >'" [ariaLabel]="genericText?.next" (click)="next()"
                            [id]="'mi-request-details-next'"></mc-button>
                    </div>

                </div>
            </div>
        </div>


    </div>
    }
    @else{
    <div id="mi-request-details-loaded">
        <mi-genral-skeleton></mi-genral-skeleton>
    </div>
    }
</div>